import request from '../../utils/request';

function existingRut(data) {
  return request({
    url: '/enrollment/initialize/existing-rut',
    method: 'POST',
    data,
  });
}

function updateLegalEnrollment(enrollmentId, data) {
  return request({
    url: `/enrollment/${enrollmentId}`,
    method: 'PATCH',
    data,
  });
}

function getLegalEnrollment(enrollmentId) {
  return request({
    url: `/enrollment/${enrollmentId}`,
    method: 'GET',
  });
}

const LegalEnrollmentApi = {
  existingRut,
  updateLegalEnrollment,
  getLegalEnrollment,
};

export default LegalEnrollmentApi;
